import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';
import toast from 'react-hot-toast';

export default function AdminDoctors() {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  const load = () => {
    setLoading(true);
    api.get('/admin/doctors').then(r => setDoctors(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const verify = async (id) => {
    try {
      await api.post('/admin/doctors/' + id + '/verify');
      toast.success('Médecin vérifié !'); load();
    } catch(e) { toast.error('Erreur'); }
  };

  const toggleAvailable = async (id, current) => {
    try {
      await api.post('/admin/doctors/' + id + '/toggle');
      toast.success(current ? 'Médecin désactivé' : 'Médecin activé'); load();
    } catch(e) { toast.error('Erreur'); }
  };

  const filtered = filter === 'all' ? doctors
    : filter === 'verified' ? doctors.filter(d => d.is_verified)
    : doctors.filter(d => !d.is_verified);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="bg-gray-800 border-b border-gray-700 px-6 py-4 flex items-center gap-3">
        <Link to="/admin/dashboard" className="text-green-400">← Retour</Link>
        <h1 className="font-bold text-lg">Gestion des médecins</h1>
      </div>

      <div className="max-w-4xl mx-auto p-6 space-y-4">
        <div className="flex gap-2">
          {[['all','Tous'],['pending','En attente'],['verified','Vérifiés']].map(([val,label]) => (
            <button key={val} onClick={() => setFilter(val)}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition-all ${filter===val ? 'bg-green-600' : 'bg-gray-700 hover:bg-gray-600'}`}>
              {label} {val === 'pending' && doctors.filter(d=>!d.is_verified).length > 0 && (
                <span className="ml-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
                  {doctors.filter(d=>!d.is_verified).length}
                </span>
              )}
            </button>
          ))}
        </div>

        {loading ? <p className="text-center text-gray-400 py-8">Chargement...</p>
        : filtered.map(doc => (
          <div key={doc.id} className="bg-gray-800 border border-gray-700 rounded-2xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="font-bold">{doc.user?.name}</p>
                <p className="text-sm text-green-400">{doc.specialty?.name_fr}</p>
                <p className="text-sm text-gray-400">📱 {doc.user?.phone}</p>
                <p className="text-sm text-gray-400">📍 {doc.city} • 🏥 {doc.clinic_name || 'Sans cabinet'}</p>
                <p className="text-sm text-gray-400">💰 {parseInt(doc.consultation_fee).toLocaleString()} FCFA</p>
                <p className="text-xs text-gray-500 mt-1">Licence: {doc.license_number}</p>
              </div>
              <div className="flex flex-col gap-2 items-end">
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${doc.is_verified ? 'bg-green-900 text-green-300' : 'bg-yellow-900 text-yellow-300'}`}>
                  {doc.is_verified ? '✅ Vérifié' : '⏳ En attente'}
                </span>
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${doc.is_available ? 'bg-blue-900 text-blue-300' : 'bg-red-900 text-red-300'}`}>
                  {doc.is_available ? '🟢 Actif' : '🔴 Inactif'}
                </span>
              </div>
            </div>
            <div className="flex gap-2 mt-3 pt-3 border-t border-gray-700">
              {!doc.is_verified && (
                <button onClick={() => verify(doc.id)}
                  className="flex-1 bg-green-600 text-white py-2 rounded-xl text-sm font-medium hover:bg-green-700">
                  ✓ Valider le médecin
                </button>
              )}
              <button onClick={() => toggleAvailable(doc.id, doc.is_available)}
                className={`flex-1 py-2 rounded-xl text-sm font-medium ${doc.is_available ? 'bg-red-900 text-red-300 hover:bg-red-800' : 'bg-blue-900 text-blue-300 hover:bg-blue-800'}`}>
                {doc.is_available ? 'Désactiver' : 'Activer'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
